import React from 'react';
import {
  TextLayoutProps,
  TextInputProps,
  InputLayoutIcon,
  TextInput,
  useInputHelper,
} from 'ui-builder';
import BaseInputLayoutWidget from '../layout/BaseInputLayoutWidget';

export {
  InputLayoutIcon,
};

export type {
  TextLayoutProps,
  TextInputProps,
};

export default TextInput;

export function TextFormField(props: {
  source: string,
  label: string,
  value?: string
}) {
  const helper = useInputHelper<string>(props);
  return (
    <BaseInputLayoutWidget {...helper.getBaseInputLayoutProps()}>
      <i>
        {helper.getValue()}
      </i>
    </BaseInputLayoutWidget>
  );
}
